<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <nte-approval>
            </nte-approval> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import nteApproval from './todo-nte-approval'
    export default {
        components: {
            nteApproval
        }
    }
    </script>
    <style lang="scss">
    /* FILE UPLOAD BUTTON  */
    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
        
    }
    
    .button {
        border: 1px solid gray;
        color: gray;
        background-color: white;
        padding: 5px 13px;
        /* border-radius: 8px; */
        /* font-size: 20px; */
        font-weight: bold;
    }
    
    .upload-btn-wrapper input[type=file] {
        font-size: 27px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        
    }
    .pointer{
        cursor: pointer;
    }
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-nte-approval.vue